import config from './../../../static/config/index.js'
import ws from '@/api/websocket.js'
import {getMsg} from "@/libs/util"
import {uuid2} from '@/libs/tools'
import {accessToken} from '@/libs/httpAccessVue'
export default {
  state:{
    WS:undefined,
    WS_MSG:undefined,
    heartCount:0
  },
  mutations: {
    setWS(state,WS){
      state.WS = WS
    },
    setWS_MSG(state, WS_MSG) {
      state.WS_MSG = WS_MSG
    },
    addHeart(state,heartCount) {
      if (heartCount === 0) {
        state.heartCount = 0
      } else {
        state.heartCount += heartCount
      }
    }
  },
  actions: {
    ws:({state,commit,rootState},{method,ext,phone,msg,heartFunc,initFunc})=> {
      // 先关闭旧的WebSocket连接，防止连接泄漏
      if (state.WS) {
        try {
          state.WS.close()
        } catch (e) {
          console.error('close old websocket error:', e)
        }
      }
      
      const {user: {userName, password, left, right,sys_user_id, control}} = rootState
      let send_text = getMsg(userName, password, left, right,sys_user_id, control, method,ext,phone, msg)
      const socket = new ws({
        url: config.ws,
        reconnectTimes: null,
        reconnect: true,
        reconnectTime: 30000,
        token: encodeURIComponent(accessToken()),
        _token_func: function () {
          return encodeURIComponent(accessToken())
        },
        heartMsg: send_text,
        _heart_func: heartFunc ? heartFunc : function () {
          commit('addHeart', 1)
        },
        _init_func: initFunc ? initFunc : function (event) {
          //websocket 连接成功回调，发送登录
          let loginMsg = getMsg(userName, password, left, right, sys_user_id, control, 'auth', ext, phone, msg)
          event.send(loginMsg)
          loginMsg = {
            userName: userName,
            method: "unread",
            username:userName,
            password:password,
            sys_user_id:sys_user_id
          }
          event.send(loginMsg)
        }
      })
      socket.onclose((event)=>{
        console.error('Websocket close,event:' + event)
      })
      commit('setWS',socket)

    },
    sendMsg:({state,commit,rootState},{method,ext,phone,msg,cont})=>{
      const {user: {userName, password, left, right,sys_user_id, control}} = rootState
      let con = control
      if (cont) {
        con = cont
      }
      let send_text = getMsg(userName, password, left, right, sys_user_id, con, method, ext, phone, msg)
      state.WS.send(send_text)
    },
    sendSelfMsg:({state,commit,rootState,dispatch},send_text)=>{
      if (!send_text.tick) {
        send_text.tick = uuid2(32).toLowerCase()
      }
      send_text.sending = true
      send_text.timestamp = new Date().getTime()
      //派发
      if (!send_text.noadd && send_text.method == 'chat') {
        dispatch('addChatMsg',send_text,{root:true})
      }
      state.WS.send(send_text)
    },
    closeWS:({state,commit})=>{
      if (state.WS) {
        state.WS.close();
      }
      //commit('setWS',undefined)
    },
    //视频和电子地图分屏后打开的页面，接受WebSocket
    setSplitScreenWS:({state,commit},{splitScreenWSA})=>{
      commit('setWS',splitScreenWSA)
    },
    //视频和电子地图分屏前获取WebSocket
    getSplitScreenWS:({state,commit})=>{
      return state.WS;
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/module/websocket.js